import { NgModule } from '@angular/core';
import { CommonHeaderComponent } from './common-header';
import { IonicModule } from 'ionic-angular';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [
    CommonHeaderComponent,
  ],
    imports: [
    CommonModule,
    IonicModule
  ],

  exports: [
    CommonHeaderComponent
  ]
})
export class CommonHeaderComponentModule {}


// WEBPACK FOOTER //
// ./src/components/common-header/common-header.module.ts